import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Index from "./pages/Index";
import About from "./pages/About";
import Elections from "./pages/Elections";
import Experience from "./pages/Experience";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import Privacy from "./pages/Privacy";
import NotFound from "./pages/NotFound";
import { AuthProvider } from "@/lib/auth";
import ScrollToTop from "@/components/ScrollToTop";
import AdminLayout from "@/components/admin/AdminLayout";
import AdminLogin from "./pages/admin/Login";
import AdminForgotPassword from "./pages/admin/ForgotPassword";
import AdminResetPassword from "./pages/admin/ResetPassword";
import AdminDashboard from "./pages/admin/Dashboard";
import { PageList, PageEditor } from "./pages/admin/Pages";
import { BlogList, BlogEditor } from "./pages/admin/Blog";
import AdminImages from "./pages/admin/Images";
import AdminUsers from "./pages/admin/Users";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/lotta" element={<About />} />
            <Route path="/politiikka" element={<Elections />} />
            <Route path="/vaalit" element={<Elections />} />
            <Route path="/osaaminen" element={<Experience />} />
            <Route path="/ota-yhteytta" element={<Contact />} />
            <Route path="/blogi" element={<Blog />} />
            <Route path="/tietosuoja" element={<Privacy />} />

            <Route path="/tietoa" element={<Navigate to="/lotta" replace />} />
            <Route path="/kokemus" element={<Navigate to="/osaaminen" replace />} />
            <Route path="/yhteystiedot" element={<Navigate to="/ota-yhteytta" replace />} />
            <Route path="/ajankohtaista" element={<Navigate to="/blogi" replace />} />

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
            <Route path="/admin/reset-password" element={<AdminResetPassword />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="sivut" element={<PageList />} />
              <Route path="sivut/:slug" element={<PageEditor />} />
              <Route path="blogi" element={<BlogList />} />
              <Route path="blogi/:id" element={<BlogEditor />} />
              <Route path="kuvat" element={<AdminImages />} />
              <Route path="kayttajat" element={<AdminUsers />} />
            </Route>

            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
